// extracted by mini-css-extract-plugin
export default {"tab":"tabs_tab__3J+ka","active":"tabs_active__an5om","tabcontent":"tabs_tabcontent__uL1m+"};